import React from "react";
import tw from "tailwind-styled-components";

const Heading = tw.h1`
text-2xl
leading-6 
text-gray-900
`;

const Content = tw.p`
my-4
`;

export default function Help() {
  React.useEffect(() => {
    const prevTitle = document.title;
    document.title = "Help - Humans.io";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="pt-10 pb-20">
      <Heading>What is Humans?</Heading>
      <Content>
        Humans is a tool to help you manage information about people in your
        life. Where did you meet? What did you talk about? Who introduced you?
      </Content>

      <Heading>Is my data safe?</Heading>
      <Content>
        Certainly. Your data is stored in the database using strong encryption.
        Only Names and Events can be decrypted, which is used to send you your
        weekly digest email.
      </Content>

      <Heading>Can I organize humans into groups?</Heading>
      <Content>
        Yes! Use hashtags to organize humans. Local #hiking friends,
        #developers, #family members, and so on. Click the hashtag to filter by
        that group.
      </Content>

      <Heading>Does it work offline?</Heading>
      <Content>
        Yes! Everything except for Avatar uploads works entirely offline. Your
        changes will be synced and merged as soon as you reconnect.
      </Content>

      <Heading>Can I download a backup of my Humans database?</Heading>
      <Content>
        Yes! Just click "Settings" at the top and you'll be able to download a
        full backup of your humans.
      </Content>

      <Heading>Does Humans work on mobile?</Heading>
      <Content>
        Yes! Simply add a bookmark to your home screen, or visit it in your
        mobile browser, and you'll have full access to your Humans database. Any
        changes you make anywhere will be instantly synced across all of your
        devices.
      </Content>

      <Heading>I have more questions</Heading>
      <Content>
        Shoot us an email and we'll help you out:{" "}
        <a href="mailto:shane+humans@reustle.org">shane+humans@reustle.org</a>
      </Content>

      <Heading>System Version</Heading>
      {/* Should not be P tag because of PRE child */}
      <div className="my-4">
        <div className="flex items-center">
          <pre className="whitespace-pre-wrap break-all">
            {import.meta.env.VITE_RELEASE_TIME} / {import.meta.env.VITE_RELEASE}
          </pre>
        </div>
      </div>
    </div>
  );
}
